<template>
  <div class="page-container">
    <el-card>
      <el-row class="gift-lucky__title"> 幸运奖池配置 </el-row>
      <!-- 搜索 -->
      <el-row class="__search">
        <el-select v-model="search.channel" filterable placeholder="请选择渠道">
          <el-option v-for="item in channelList" :key="item.channelId" :label="item.name" :value="item.value">
          </el-option>
        </el-select>
        <el-select v-model="search.sonPool" filterable placeholder="请选择奖池">
          <el-option v-for="item in sonPoolList" :key="item.sonPoolId" :label="item.name" :value="item.value">
          </el-option>
        </el-select>
        <el-button style="margin-left: 10px" type="primary" @click="getLuckGiftConfig">查询</el-button>
        <el-button style="margin-left: 10px" type="primary" @click="createState = true">新建配置</el-button>
      </el-row>
      <!-- 配置信息 -->
      <el-row>
        <el-collapse v-model="activeNames">
          <!-- 分配配置 -->
          <el-collapse-item title="分配配置" name="1">
            <el-form :model="luckGift.list">
              <el-descriptions :column="4" border>
                <template slot="extra">
                  <el-button type="primary" size="small" @click="luckGift.distributionUpdateState = true"
                    :disabled="luckGift.distributionUpdateState">编辑</el-button>
                </template>
                <el-descriptions-item>
                  <template slot="label"> 渠道 </template>
                  {{ luckGift.list.channel }}
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label"> 子奖池 </template>
                  <el-select :disabled="true" v-model="luckGift.list.sonPool" filterable
                    placeholder="请选择子奖池">
                    <el-option v-for="(item, index) in sonPoolList" :key="index" :label="item.name"
                      :value="item.value"></el-option>
                  </el-select>
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label">是否有效</template>
                  <el-switch active-text="有效" inactive-text="无效" :active-value="1" :inactive-value="0"
                    :disabled="!luckGift.distributionUpdateState" v-model="luckGift.list.valid">
                  </el-switch>
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label">
                    系统回收比例 （ 期望传递万分率 eg 0.03% 传递 3）</template>
                  <el-input v-model="luckGift.list.distribution.system"
                    :disabled="!luckGift.distributionUpdateState"></el-input>
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label"> 主播分成比例 </template>
                  <el-input v-model="luckGift.list.distribution.host"
                    :disabled="!luckGift.distributionUpdateState"></el-input>
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label"> jackpot奖池分配比例 </template>
                  <el-input v-model="luckGift.list.distribution.jackpotPool"
                    :disabled="!luckGift.distributionUpdateState"></el-input>
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label"> 个人保底奖池分配比例 </template>
                  <el-input v-model="luckGift.list.distribution.guaranteedPool"
                    :disabled="!luckGift.distributionUpdateState"></el-input>
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label"> 兜底奖池分配比例 </template>
                  <el-input v-model="luckGift.list.distribution.pool"
                    :disabled="!luckGift.distributionUpdateState"></el-input>
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label"> 指定奖池礼物id列表 </template>
                  <el-button type="primary" size="small" @click="openSonPool(luckGift.list.distribution.giftIds)"
                    :disabled="!luckGift.distributionUpdateState">编辑列表</el-button>
                </el-descriptions-item>

              </el-descriptions>
            </el-form>
            <template v-if="luckGift.distributionUpdateState">
              <div style="
                  margin-top: 20px;
                  display: flex;
                  justify-content: flex-end;
                ">
                <el-button @click="luckGift.distributionUpdateState = false" size="small">取消</el-button>
                <el-button @click="updateLuckyGifitConfig(luckGift.distributionUpdateState)" size="small"
                  type="primary">提交</el-button>
              </div>
            </template>
          </el-collapse-item>
          <!-- jackpot奖池配置 -->
          <el-collapse-item title="jackpot奖池配置" name="2">
            <el-form :model="luckGift.list">
              <el-descriptions :column="4" border>
                <template slot="extra">
                  <el-button type="primary" size="small" @click="luckGift.jackpotConfigState = true"
                    :disabled="luckGift.jackpotConfigState">编辑</el-button>
                </template>
                <el-descriptions-item>
                  <template slot="label">jackpot开关</template>
                  <el-switch v-model="luckGift.list.jackpotConfig.jackpotSwitch"
                    :disabled="!luckGift.jackpotConfigState">
                  </el-switch>
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label"> jackpot概率 (期望万分率)</template>
                  <el-input v-model="luckGift.list.jackpotConfig.rate"
                    :disabled="!luckGift.jackpotConfigState"></el-input>
                </el-descriptions-item>
              </el-descriptions>
              <template>
                <el-row style="margin-top: 20px">
                  <span style="margin-right: 10px">返奖列表</span>
                  <el-button size="small" @click="
                    luckGift.list.jackpotConfig.multiConfigList.unshift({
                      multi: 0,
                      rate: 0,
                    })
                    " :disabled="!luckGift.jackpotConfigState">添加</el-button>
                </el-row>
                <el-row v-for="(item, index) in luckGift.list.jackpotConfig
                  .multiConfigList">
                  <span>返奖倍数:</span>
                  <el-input type="Number" placeholder="输入返奖倍数" v-model="item.multi"
                    style="width: 300px; margin-right: 10px" :disabled="!luckGift.jackpotConfigState"></el-input>
                  <span>返奖概率:</span>
                  <el-input type="Number" v-model="item.rate" placeholder="输入返奖概率"
                    style="width: 300px; margin-right: 10px" :disabled="!luckGift.jackpotConfigState"></el-input>
                  <el-button size="small" @click="
                    luckGift.list.jackpotConfig.multiConfigList.splice(
                      index,
                      1
                    )
                    " :disabled="!luckGift.jackpotConfigState">删除</el-button>
                </el-row>
              </template>
            </el-form>
            <template v-if="luckGift.jackpotConfigState">
              <div style="
                  margin-top: 20px;
                  display: flex;
                  justify-content: flex-end;
                ">
                <el-button @click="luckGift.jackpotConfigState = false" size="small">取消</el-button>
                <el-button @click="updateLuckyGifitConfig" size="small" type="primary">提交</el-button>
              </div>
            </template>
          </el-collapse-item>
          <!-- 个人保底奖池配置 -->
          <el-collapse-item title="个人保底奖池配置" name="3">
            <el-form :model="luckGift.list">
              <el-descriptions :column="4" border>
                <template slot="extra">
                  <el-button type="primary" size="small" @click="luckGift.guaranteedConfigState = true"
                    :disabled="luckGift.guaranteedConfigState">编辑</el-button>
                </template>
                <el-descriptions-item>
                  <template slot="label">个人保底开关</template>
                  <el-switch v-model="luckGift.list.guaranteedConfig.guaranteedSwitch"
                    :disabled="!luckGift.guaranteedConfigState">
                  </el-switch>
                </el-descriptions-item>
              </el-descriptions>
              <template>
                <el-row style="margin-top: 20px">
                  <span style="margin-right: 10px">分割奖池</span>
                  <el-button size="small" @click="poolAdd(1)" :disabled="!luckGift.guaranteedConfigState">添加</el-button>
                </el-row>
                <el-row v-for="(item, index) in luckGift.list.guaranteedConfig
                  .poolConfigs">
                  <span>分奖key:</span>
                  <el-input placeholder="输入分奖key" v-model="item.poolKey" style="width: 300px; margin-right: 10px"
                    :disabled="!luckGift.guaranteedConfigState" @input="onInput"></el-input>
                  <el-button size="small" @click="
                    () => {
                      luckGift.list.guaranteedConfig.poolConfigs.splice(
                        index,
                        1
                      )
                      $forceUpdate()
                    }
                  " :disabled="!luckGift.guaranteedConfigState">删除</el-button>
                  <el-row v-for="(items, i) in item.giftIds" :key="i">
                    <span>礼物id:</span>
                    <el-input type="Number" v-model="item.giftIds[i]" placeholder="输入礼物id"
                      style="width: 100px; margin: 5px 10px 0" :disabled="!luckGift.guaranteedConfigState"
                      @input="onInput"></el-input>
                    <el-button size="small" @click="
                      () => {
                        luckGift.list.guaranteedConfig.poolConfigs[
                          index
                        ].giftIds.splice(i, 1)
                        $forceUpdate()
                      }
                    " :disabled="!luckGift.guaranteedConfigState">删除</el-button>
                  </el-row>
                  <div style="
                      height: 30px;
                      width: 30px;
                      font-size: 20px;
                      line-height: 30px;
                      text-align: center;
                      border: 1px solid #ccc;
                      border-radius: 50%;
                      cursor: pointer;
                    " @click="
                      () => {
                        if (!luckGift.guaranteedConfigState) return
                        item.giftIds.unshift(0)
                        $forceUpdate()
                      }
                    ">
                    +
                  </div>
                </el-row>
              </template>
              <template>
                <el-row style="margin-top: 20px">
                  <span style="margin-right: 10px">返奖列表</span>
                  <el-button size="small" @click="
                    luckGift.list.guaranteedConfig.multiConfigList.unshift({
                      multi: 0,
                      rate: 0,
                    })
                    " :disabled="!luckGift.guaranteedConfigState">添加</el-button>
                </el-row>
                <el-row v-for="(item, index) in luckGift.list.guaranteedConfig
                  .multiConfigList" :key="index">
                  <span>返奖倍数:</span>
                  <el-input type="Number" placeholder="输入返奖倍数" v-model="item.multi"
                    style="width: 300px; margin-right: 10px" :disabled="!luckGift.guaranteedConfigState"></el-input>
                  <span>返奖概率:</span>
                  <el-input type="Number" v-model="item.rate" placeholder="输入返奖概率"
                    style="width: 300px; margin-right: 10px" :disabled="!luckGift.guaranteedConfigState"></el-input>
                  <el-button size="small" @click="
                    luckGift.list.guaranteedConfig.multiConfigList.splice(
                      index,
                      1
                    )
                    " :disabled="!luckGift.guaranteedConfigState">删除</el-button>
                </el-row>
              </template>
            </el-form>
            <template v-if="luckGift.guaranteedConfigState">
              <div style="
                  margin-top: 20px;
                  display: flex;
                  justify-content: flex-end;
                ">
                <el-button @click="luckGift.guaranteedConfigState = false" size="small">取消</el-button>
                <el-button @click="updateLuckyGifitConfig" size="small" type="primary">提交</el-button>
              </div>
            </template>
          </el-collapse-item>
          <!-- 兜底奖池配置 -->
          <el-collapse-item title="兜底奖池配置" name="4">
            <el-form :model="luckGift.list">
              <el-descriptions :column="4" border>
                <template slot="extra">
                  <el-button type="primary" size="small" @click="luckGift.poolConfigState = true"
                    :disabled="luckGift.poolConfigState">编辑</el-button>
                </template>
                <el-descriptions-item>
                  <template slot="label"> 兜底奖池上限值 </template>
                  <el-input v-model="luckGift.list.poolConfig.maxLimit"
                    :disabled="!luckGift.poolConfigState"></el-input>
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label"> 兜底奖池下限值 </template>
                  <el-input v-model="luckGift.list.poolConfig.minLimit"
                    :disabled="!luckGift.poolConfigState"></el-input>
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label">
                    兜底达上限奖池控制的触发概率 期望 万分率
                  </template>
                  <el-input v-model="luckGift.list.poolConfig.maxRate" :disabled="!luckGift.poolConfigState"></el-input>
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label">
                    兜底达下限奖池控制的触发概率 期望 万分率
                  </template>
                  <el-input v-model="luckGift.list.poolConfig.minRate" :disabled="!luckGift.poolConfigState"></el-input>
                </el-descriptions-item>
              </el-descriptions>
              <template>
                <el-row style="margin-top: 20px">
                  <span style="margin-right: 10px">返奖列表</span>
                  <el-button size="small" @click="
                    luckGift.list.poolConfig.poolMultiList.unshift({
                      multi: 0,
                      rate: 0,
                    })
                    " :disabled="!luckGift.poolConfigState">添加</el-button>
                </el-row>
                <el-row v-for="(item, index) in luckGift.list.poolConfig
                  .poolMultiList">
                  <span>返奖倍数:</span>
                  <el-input type="Number" placeholder="输入返奖倍数" v-model="item.multi"
                    style="width: 300px; margin-right: 10px" :disabled="!luckGift.poolConfigState"></el-input>
                  <span>返奖概率:</span>
                  <el-input type="Number" v-model="item.rate" placeholder="输入返奖概率"
                    style="width: 300px; margin-right: 10px" :disabled="!luckGift.poolConfigState"></el-input>
                  <el-button size="small" @click="
                    luckGift.list.poolConfig.poolMultiList.splice(index, 1)
                    " :disabled="!luckGift.poolConfigState">删除</el-button>
                </el-row>
              </template>
            </el-form>
            <template v-if="luckGift.poolConfigState">
              <div style="
                  margin-top: 20px;
                  display: flex;
                  justify-content: flex-end;
                ">
                <el-button @click="luckGift.poolConfigState = false" size="small">取消</el-button>
                <el-button @click="updateLuckyGifitConfig" size="small" type="primary">提交</el-button>
              </div>
            </template>
          </el-collapse-item>
          <!-- 兜底放水奖池 -->
          <el-collapse-item title="兜底放水奖池配置" name="5">
            <el-form :model="luckGift.list">
              <template>
                <el-row style="margin-top: 20px">
                  <span style="margin-right: 10px">返奖列表</span>
                  <el-button size="small" @click="
                    luckGift.list.poolConfig.waterproofMultiList.unshift({
                      multi: 0,
                      rate: 0,
                    })
                    " :disabled="!luckGift.poolConfigState">添加</el-button>
                </el-row>
                <el-row v-for="(item, index) in luckGift.list.poolConfig
                  .waterproofMultiList">
                  <span>返奖倍数:</span>
                  <el-input type="Number" placeholder="输入返奖倍数" v-model="item.multi"
                    style="width: 300px; margin-right: 10px" :disabled="!luckGift.poolConfigState"></el-input>
                  <span>返奖概率:</span>
                  <el-input type="Number" v-model="item.rate" placeholder="输入返奖概率"
                    style="width: 300px; margin-right: 10px" :disabled="!luckGift.poolConfigState"></el-input>
                  <el-button size="small" @click="
                    luckGift.list.poolConfig.waterproofMultiList.splice(
                      index,
                      1
                    )
                    " :disabled="!luckGift.poolConfigState">删除</el-button>
                </el-row>
              </template>
            </el-form>
            <template v-if="luckGift.waterPoolConfigState">
              <div style="
                  margin-top: 20px;
                  display: flex;
                  justify-content: flex-end;
                ">
                <el-button @click="luckGift.waterPoolConfigState = false" size="small">取消</el-button>
                <el-button @click="updateLuckyGifitConfig" size="small" type="primary">提交</el-button>
              </div>
            </template>
          </el-collapse-item>
          <!-- 点控相关配置 （高返奖）-->
          <el-collapse-item title="点控相关配置（高返奖）" name="6">
            <el-form :model="luckGift.list">
              <el-descriptions :column="4" border>
                <template slot="extra">
                  <el-button type="primary" size="small" @click="luckGift.pointConfigBigState = true"
                    :disabled="luckGift.pointConfigBigState">编辑</el-button>
                </template>
                <el-descriptions-item>
                  <template slot="label">点控开关</template>
                  <el-switch v-model="luckGift.list.pointConfig.pointSwitch" :disabled="!luckGift.pointConfigBigState">
                  </el-switch>
                </el-descriptions-item>
              </el-descriptions>
              <template>
                <el-row style="margin-top: 20px">
                  <span style="margin-right: 10px">返奖列表</span>
                  <el-button size="small" @click="
                    luckGift.list.pointConfig.bigMultiList.unshift({
                      multi: 0,
                      rate: 0,
                    })
                    " :disabled="!luckGift.pointConfigBigState">添加</el-button>
                </el-row>
                <el-row v-for="(item, index) in luckGift.list.pointConfig
                  .bigMultiList">
                  <span>返奖倍数:</span>
                  <el-input type="Number" placeholder="输入返奖倍数" v-model="item.multi"
                    style="width: 300px; margin-right: 10px" :disabled="!luckGift.pointConfigBigState"></el-input>
                  <span>返奖概率:</span>
                  <el-input type="Number" v-model="item.rate" placeholder="输入返奖概率"
                    style="width: 300px; margin-right: 10px" :disabled="!luckGift.pointConfigBigState"></el-input>
                  <el-button size="small" @click="
                    luckGift.list.pointConfig.bigMultiList.splice(index, 1)
                    " :disabled="!luckGift.pointConfigBigState">删除</el-button>
                </el-row>
              </template>
            </el-form>
            <template v-if="luckGift.pointConfigBigState">
              <div style="
                  margin-top: 20px;
                  display: flex;
                  justify-content: flex-end;
                ">
                <el-button @click="luckGift.pointConfigBigState = false" size="small">取消</el-button>
                <el-button @click="updateLuckyGifitConfig" size="small" type="primary">提交</el-button>
              </div>
            </template>
          </el-collapse-item>
          <!-- 点控相关配置 （低返奖）-->
          <el-collapse-item title="点控相关配置（低返奖）" name="7">
            <el-form :model="luckGift.list">
              <el-descriptions :column="4" border>
                <template slot="extra">
                  <el-button type="primary" size="small" @click="luckGift.pointConfigSmallState = true"
                    :disabled="luckGift.pointConfigSmallState">编辑</el-button>
                </template>
              </el-descriptions>
              <template>
                <el-row style="margin-top: 20px">
                  <span style="margin-right: 10px">返奖列表</span>
                  <el-button size="small" @click="
                    luckGift.list.pointConfig.smallMultiList.unshift({
                      multi: 0,
                      rate: 0,
                    })
                    " :disabled="!luckGift.pointConfigSmallState">添加</el-button>
                </el-row>
                <el-row v-for="(item, index) in luckGift.list.pointConfig
                  .smallMultiList">
                  <span>返奖倍数:</span>
                  <el-input type="Number" placeholder="输入返奖倍数" v-model="item.multi"
                    style="width: 300px; margin-right: 10px" :disabled="!luckGift.pointConfigSmallState"></el-input>
                  <span>返奖概率:</span>
                  <el-input type="Number" v-model="item.rate" placeholder="输入返奖概率"
                    style="width: 300px; margin-right: 10px" :disabled="!luckGift.pointConfigSmallState"></el-input>
                  <el-button size="small" @click="
                    luckGift.list.pointConfig.smallMultiList.splice(index, 1)
                    " :disabled="!luckGift.pointConfigSmallState">删除</el-button>
                </el-row>
              </template>
            </el-form>
            <template v-if="luckGift.pointConfigSmallState">
              <div style="
                  margin-top: 20px;
                  display: flex;
                  justify-content: flex-end;
                ">
                <el-button @click="luckGift.pointConfigSmallState = false" size="small">取消</el-button>
                <el-button @click="updateLuckyGifitConfig" size="small" type="primary">提交</el-button>
              </div>
            </template>
          </el-collapse-item>
          <!-- 奖池展示 -->
          <el-collapse-item title="奖池展示" name="8">
            <el-descriptions class="margin-top" :column="3" border>
              <el-descriptions-item>
                <template slot="label"> 兜底奖池 </template>
                {{ luckGift.list.poolBalance }}
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label"> jackpot奖池 </template>
                {{ luckGift.list.jackpotBalance }}
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label"> 个人保底奖池总额 </template>
                {{ luckGift.list.guaranteedBalance }}
              </el-descriptions-item>
            </el-descriptions>
          </el-collapse-item>
        </el-collapse>
      </el-row>
      <!-- 新建配置 -->
      <el-dialog :fullscreen="fullscreen" :visible.sync="createState" :close-on-press-escape="false"
        :show-close="false">
        <el-row style="font-size: 22px">创建幸运礼物奖池配置</el-row>
        <el-row>
          <el-collapse v-model="activeNames">
            <!-- 分配配置 -->
            <el-collapse-item title="分配配置" name="1">
              <el-form :model="createLuckGift.list">
                <el-descriptions :column="4" border>
                  <el-descriptions-item>
                    <template slot="label"> 渠道 </template>
                    <el-select v-model="createLuckGift.list.channel" filterable placeholder="请选择渠道">
                      <el-option v-for="item in channelList" :key="item.channelId" :label="item.name"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </el-descriptions-item>
                  <el-descriptions-item>
                    <template slot="label"> 子奖池 </template>
                    <el-select v-model="createLuckGift.list.sonPool" filterable placeholder="请选择子奖池">
                      <el-option v-for="item in sonPoolList" :key="item.value" :label="item.name"
                        :value="item.value"></el-option>
                    </el-select>
                  </el-descriptions-item>
                  <el-descriptions-item>
                    <template slot="label">是否有效</template>
                    <el-switch active-text="有效" inactive-text="无效" active-value="1" inactive-value="0"
                      v-model="createLuckGift.list.valid">
                    </el-switch>
                  </el-descriptions-item>
                  <el-descriptions-item>
                    <template slot="label">
                      系统回收比例 （ 期望传递万分率 eg 0.03% 传递
                      3）（必填）</template>
                    <el-input v-model="createLuckGift.list.distribution.system"></el-input>
                  </el-descriptions-item>
                  <el-descriptions-item>
                    <template slot="label"> 主播分成比例 （必填）</template>
                    <el-input v-model="createLuckGift.list.distribution.jackpotPool"></el-input>
                  </el-descriptions-item>
                  <el-descriptions-item>
                    <template slot="label">
                      jackpot奖池分配比例（必填）
                    </template>
                    <el-input v-model="createLuckGift.list.distribution.host"></el-input>
                  </el-descriptions-item>
                  <el-descriptions-item>
                    <template slot="label">
                      个人保底奖池分配比例 （必填）</template>
                    <el-input v-model="createLuckGift.list.distribution.guaranteedPool"></el-input>
                  </el-descriptions-item>
                  <el-descriptions-item>
                    <template slot="label"> 兜底奖池分配比例 （必填）</template>
                    <el-input v-model="createLuckGift.list.distribution.pool"></el-input>
                  </el-descriptions-item>
                  <el-descriptions-item>
                    <template slot="label"> 指定奖池礼物id列表 </template>
                    <el-button type="primary" size="small" @click="openSonPool(createLuckGift.list.distribution.giftIds, 1)">编辑列表</el-button>
                  </el-descriptions-item>
                </el-descriptions>
              </el-form>
            </el-collapse-item>
            <!-- jackpot奖池配置 -->
            <el-collapse-item title="jackpot奖池配置" name="2">
              <el-form :model="createLuckGift.list">
                <el-descriptions :column="4" border>
                  <el-descriptions-item>
                    <template slot="label">jackpot开关</template>
                    <el-switch v-model="createLuckGift.list.jackpotConfig.jackpotSwitch">
                    </el-switch>
                  </el-descriptions-item>
                  <el-descriptions-item>
                    <template slot="label"> jackpot概率 (期望万分率)</template>
                    <el-input v-model="createLuckGift.list.jackpotConfig.rate"></el-input>
                  </el-descriptions-item>
                  <template v-for="(item, index) in createLuckGift.list.jackpotConfig
                    .multiConfigList">
                    <el-descriptions-item>
                      <template slot="label">返奖倍数 数字</template>
                      <el-input v-model="item.multi" type="number"></el-input>
                    </el-descriptions-item>
                    <el-descriptions-item>
                      <template slot="label">概率</template>
                      <el-input v-model="item.rate"></el-input>
                    </el-descriptions-item>
                  </template>
                </el-descriptions>
              </el-form>
            </el-collapse-item>
            <!-- 个人保底奖池配置 -->
            <el-collapse-item title="个人保底奖池配置" name="3">
              <el-form :model="createLuckGift.list">
                <el-descriptions :column="4" border>
                  <el-descriptions-item>
                    <template slot="label">个人保底开关</template>
                    <el-switch v-model="createLuckGift.list.guaranteedConfig.guaranteedSwitch
                      ">
                    </el-switch>
                  </el-descriptions-item>
                  <template v-for="(item, index) in createLuckGift.list.guaranteedConfig
                    .multiConfigList">
                    <el-descriptions-item>
                      <template slot="label">返奖倍数 数字</template>
                      <el-input v-model="item.multi" type="number"></el-input>
                    </el-descriptions-item>
                    <el-descriptions-item>
                      <template slot="label">概率</template>
                      <el-input v-model="item.rate"></el-input>
                    </el-descriptions-item>
                  </template>
                </el-descriptions>
              </el-form>
              <template>
                <el-row style="margin-top: 20px">
                  <span style="margin-right: 10px">分割奖池</span>
                  <el-button size="small" @click="poolAdd(2)">添加</el-button>
                </el-row>
                <el-row v-for="(item, index) in createLuckGift.list.guaranteedConfig
                  .poolConfigs">
                  <span>分奖key:</span>
                  <el-input placeholder="输入分奖key" v-model="item.poolKey"
                    style="width: 300px; margin-right: 10px"></el-input>
                  <el-button size="small" @click="
                    createLuckGift.list.guaranteedConfig.poolConfigs.splice(
                      index,
                      1
                    )
                    ">删除</el-button>
                  <el-row v-for="(items, i) in item.giftIds" :key="i">
                    <span>礼物id:</span>
                    <el-input type="Number" v-model="item.giftIds[i]" placeholder="输入礼物id"
                      style="width: 100px; margin: 5px 10px 0"></el-input>
                    <el-button size="small" @click="item.giftIds.splice(i, 1)">删除</el-button>
                  </el-row>
                  <div style="
                      height: 30px;
                      width: 30px;
                      font-size: 20px;
                      line-height: 30px;
                      text-align: center;
                      border: 1px solid #ccc;
                      border-radius: 50%;
                      cursor: pointer;
                    " @click="item.giftIds.unshift(0)">
                    +
                  </div>
                </el-row>
              </template>
            </el-collapse-item>
            <!-- 兜底奖池配置 -->
            <el-collapse-item title="兜底奖池配置" name="4">
              <el-form :model="createLuckGift.list">
                <el-descriptions :column="4" border>
                  <el-descriptions-item>
                    <template slot="label"> 兜底奖池上限值 </template>
                    <el-input v-model="createLuckGift.list.poolConfig.maxLimit"></el-input>
                  </el-descriptions-item>
                  <el-descriptions-item>
                    <template slot="label"> 兜底奖池下限值 </template>
                    <el-input v-model="createLuckGift.list.poolConfig.minLimit"></el-input>
                  </el-descriptions-item>
                  <el-descriptions-item>
                    <template slot="label">
                      兜底达上限奖池控制的触发概率 期望 万分率
                    </template>
                    <el-input v-model="createLuckGift.list.poolConfig.maxRate"></el-input>
                  </el-descriptions-item>
                  <el-descriptions-item>
                    <template slot="label">
                      兜底达下限奖池控制的触发概率 期望 万分率
                    </template>
                    <el-input v-model="createLuckGift.list.poolConfig.minRate"></el-input>
                  </el-descriptions-item>
                  <template v-for="(item, index) in createLuckGift.list.poolConfig
                    .poolMultiList">
                    <el-descriptions-item>
                      <template slot="label">普通奖池返奖倍数 数字</template>
                      <el-input v-model="item.multi" type="number"></el-input>
                    </el-descriptions-item>
                    <el-descriptions-item>
                      <template slot="label">普通奖池概率</template>
                      <el-input v-model="item.rate"></el-input>
                    </el-descriptions-item>
                  </template>
                </el-descriptions>
              </el-form>
            </el-collapse-item>
            <!-- 兜底放水奖池 -->
            <el-collapse-item title="兜底放水奖池配置" name="5">
              <el-form :model="createLuckGift.list">
                <el-descriptions :column="4" border>
                  <template v-for="(item, index) in createLuckGift.list.poolConfig
                    .waterproofMultiList">
                    <el-descriptions-item>
                      <template slot="label">放水奖池返奖倍数 数字</template>
                      <el-input v-model="item.multi" type="number"></el-input>
                    </el-descriptions-item>
                    <el-descriptions-item>
                      <template slot="label">放水奖池概率</template>
                      <el-input v-model="item.rate"></el-input>
                    </el-descriptions-item>
                  </template>
                </el-descriptions>
              </el-form>
            </el-collapse-item>
            <!-- 点控相关配置（高返奖 ）-->
            <el-collapse-item title="点控相关配置（高返奖）" name="6">
              <el-form :model="createLuckGift.list">
                <el-descriptions :column="4" border>
                  <el-descriptions-item>
                    <template slot="label">点控开关</template>
                    <el-switch v-model="createLuckGift.list.pointConfig.pointSwitch">
                    </el-switch>
                  </el-descriptions-item>
                  <template v-for="(item, index) in createLuckGift.list.pointConfig
                    .bigMultiList">
                    <el-descriptions-item>
                      <template slot="label">返奖倍数 数字</template>
                      <el-input v-model="item.multi" type="number"></el-input>
                    </el-descriptions-item>
                    <el-descriptions-item>
                      <template slot="label">概率</template>
                      <el-input v-model="item.rate"></el-input>
                    </el-descriptions-item>
                  </template>
                </el-descriptions>
              </el-form>
            </el-collapse-item>
            <!-- 点控相关配置（低返奖） -->
            <el-collapse-item title="点控相关配置（低返奖）" name="6">
              <el-form :model="createLuckGift.list">
                <el-descriptions :column="4" border>
                  <template v-for="(item, index) in createLuckGift.list.pointConfig
                    .smallMultiList">
                    <el-descriptions-item>
                      <template slot="label">返奖倍数 数字</template>
                      <el-input v-model="item.multi" type="number"></el-input>
                    </el-descriptions-item>
                    <el-descriptions-item>
                      <template slot="label">概率</template>
                      <el-input v-model="item.rate"></el-input>
                    </el-descriptions-item>
                  </template>
                </el-descriptions>
              </el-form>
            </el-collapse-item>
          </el-collapse>
        </el-row>
        <!-- 添加各个奖池返奖配置 -->
        <el-row>
          <el-select v-model="createLuckGift.multiConfig" placeholder="请选择">
            <el-option v-for="item in createLuckGift.options" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <el-input v-model="createLuckGift.multi" type="number" style="width: 200px; margin-left: 20px"
            placeholder="请输入返奖倍数"></el-input>
          <el-input v-model="createLuckGift.rate" style="width: 200px; margin-left: 20px"
            placeholder="请输入概率"></el-input>
          <el-popconfirm title="确认添加？" @confirm="addMultiConfig">
            <el-button style="margin-left: 20px" type="primary" slot="reference">添加</el-button>
          </el-popconfirm>
        </el-row>
        <el-row>
          <div class="btn-group" style="display: flex; justify-content: flex-end">
            <el-popconfirm title="确认创建？" @confirm="createLuckyGifitConfig">
              <el-button style="margin-left: 20px" type="primary" slot="reference">创建</el-button>
            </el-popconfirm>
            <el-button style="margin-left: 20px" type="primary" @click="createState = false">暂存</el-button>
            <el-button style="margin-left: 20px" type="primary" @click="clearCreate">取消</el-button>
          </div>
        </el-row>
      </el-dialog>
      <el-dialog title="指定奖池礼物id列表" :visible.sync="sonPoolVisible" width="30%" @close="closeSonPool">
        <el-row>
          <el-input style="width: 200px; margin-right: 10px" v-model="sonPool.giftId" placeholder="请输入礼物id"></el-input>
          <el-button style="margin-left: 20px" type="primary" @click="addSonPoolGiftId">添加</el-button>
          <el-table border :data="giftIds">
            <el-table-column label="礼物id" align="center">
              <template slot-scope="scope">
                {{ scope.row }}
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button type="primary" size="small" @click="giftIds.splice(scope.$index, 1)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-button style="margin: 20px 10px 0 0" type="primary" @click="closeSonPool">关闭</el-button>
          <el-button type="primary" @click="saveSonPoolGiftId">保存</el-button>
        </el-row>
      </el-dialog>
    </el-card>
    <!-- 个人保底 -->
    <el-card class="card">
      <el-row class="gift-lucky__title"> 个人保底列表 </el-row>
      <!-- 搜索 -->
      <el-row class="__search">
        <el-input v-model="guaranteed.rid" style="width: 300px" placeholder="请输入用户ID"></el-input>
        <el-button style="margin-left: 10px" type="primary" @click="getGuaranteed(1)">查询</el-button>
      </el-row>
      <!-- 表格 -->
      <el-row>
        <el-table border :data="guaranteed.list">
          <el-table-column prop="rid" label="用户id" align="center"></el-table-column>
          <!-- <el-table-column
            prop="count"
            label="数量"
            align="center"
          ></el-table-column> -->
          <el-table-column label="分割奖池" align="center">
            <template slot-scope="scope">
              <div v-if="scope.row.pool && scope.row.pool.list">
                <div class="pool__item" v-for="(item, index) in scope.row.pool.list" :key="index">
                  {{ item.poolKey }}:{{ item.poolBalance }}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="nextMulti" label="下一次中奖率" align="center"></el-table-column>
        </el-table>
      </el-row>
      <!-- 分页 -->
      <el-row>
        <el-pagination background layout="prev, pager, next" :total="guaranteed.total" :page-size="guaranteed.pageSize"
          :current-page.sync="guaranteed.currengPage" @current-change="guaranteedHandleCurrentChange">
        </el-pagination>
      </el-row>
    </el-card>
  </div>
</template>

<script>
import { data } from 'jquery'

export default {
  data() {
    return {
      sonPoolVisible: false,
      giftIds: [],
      sonPool: {
        giftId: null,
      },
      fullscreen: true,
      activeNames: ['1', '2', '3', '4', '5', '8'],
      //个人保底
      guaranteed: {
        rid: null,
        list: [],
        pageSize: 30,
        total: 0,
        currengPage: 1,
      },
      createState: false,
      search: {
        channel: null,
        sonPool: null
      },
      //幸运奖池配置
      luckGift: {
        distributionUpdateState: false,
        jackpotConfigState: false,
        guaranteedConfigState: false,
        poolConfigState: false,
        waterPoolConfigState: false,
        pointConfigBigState: false,
        pointConfigSmallState: false,
        list: {
          valid: 0,
          sonPool: null,
          id: null,
          channel: null,
          //分配配置
          distribution: {},
          //jockpot奖池配置
          jackpotConfig: {
            multiConfigList: [],
          },
          //个人保收奖池配置
          guaranteedConfig: {
            multiConfigList: [],
            // 分割奖池
            poolConfigs: [{ poolKey: null, giftIds: [0] }],
          },
          //兜底奖池配置
          poolConfig: {
            poolMultiList: [],
            waterproofMultiList: [],
          },
          //点控配置
          pointConfig: {
            bigMultiList: [],
            smallMultiList: [],
          },
          // 兜底奖池
          poolBalance: 0,
          // jackpot奖池
          jackpotBalance: 0,
          // 个人保底奖池总额
          guaranteedBalance: 0,
        },
      },
      //新建幸运礼物配置
      createLuckGift: {
        options: [
          {
            value: 'jackpotConfig',
            label: 'jackpot奖池返奖倍率列表',
          },
          {
            value: 'guaranteedConfig',
            label: '个人保收奖池奖池返奖倍率列表',
          },
          {
            value: 'poolMultiList',
            label: '兜底普通奖池返奖倍率列表',
          },
          {
            value: 'waterproofMultiList',
            label: '兜底放水奖池返奖倍率列表',
          },
          {
            value: 'bigMultiList',
            label: '点控高返奖倍率列表',
          },
          {
            value: 'smallMultiList',
            label: '点控低返奖倍率列表',
          },
        ],
        multiConfig: '',
        multi: null,
        rate: null,
        list: {
          valid: 0,
          channel: null,
          //分配配置
          distribution: {
            system: 0,
            jackpotPool: 0,
            host: 0,
            guaranteedPool: 0,
            pool: 0,
          },
          //jockpot奖池配置
          jackpotConfig: {
            jackpotSwitch: 0,
            rate: 0,
            multiConfigList: [],
          },
          //个人保收奖池配置
          guaranteedConfig: {
            guaranteedSwitch: 0,
            multiConfigList: [],
            poolConfigs: [],
          },
          //兜底奖池配置
          poolConfig: {
            maxLimit: 0,
            maxRate: 0,
            minLimit: 0,
            minRate: 0,
            poolMultiList: [],
            waterproofMultiList: [],
          },
          //点控配置
          pointConfig: {
            pointSwitch: 0,
            bigMultiList: [],
            smallMultiList: [],
          },
          // 兜底奖池
          poolBalance: 0,
          // jackpot奖池
          jackpotBalance: 0,
          // 个人保底奖池总额
          guaranteedBalance: 0,
        },
      },
      //置空模板
      clearTemplete: {
        options: [
          {
            value: 'jackpotConfig',
            label: 'jackpot奖池返奖倍率列表',
          },
          {
            value: 'guaranteedConfig',
            label: '个人保收奖池奖池返奖倍率列表',
          },
          {
            value: 'poolMultiList',
            label: '兜底普通奖池返奖倍率列表',
          },
          {
            value: 'waterproofMultiList',
            label: '兜底放水奖池返奖倍率列表',
          },
          {
            value: 'bigMultiList',
            label: '点控高返奖倍率列表',
          },
          {
            value: 'smallMultiList',
            label: '点控低返奖倍率列表',
          },
        ],
        multiConfig: '',
        multi: null,
        rate: null,
        list: {
          valid: 0,
          channel: null,
          //分配配置
          distribution: {
            system: 0,
            jackpotPool: 0,
            host: 0,
            guaranteedPool: 0,
            pool: 0,
          },
          //jockpot奖池配置
          jackpotConfig: {
            jackpotSwitch: 0,
            rate: 0,
            multiConfigList: [],
          },
          //个人保收奖池配置
          guaranteedConfig: {
            guaranteedSwitch: 0,
            multiConfigList: [],
            poolConfigs: [],
          },
          current: 0,
          //兜底奖池配置
          poolConfig: {
            maxLimit: 0,
            maxRate: 0,
            minLimit: 0,
            minRate: 0,
            poolMultiList: [],
            waterproofMultiList: [],
          },
          //点控配置
          pointConfig: {
            pointSwitch: 0,
            bigMultiList: [],
            smallMultiList: [],
          },
          // 兜底奖池
          poolBalance: 0,
          // jackpot奖池
          jackpotBalance: 0,
          // 个人保底奖池总额
          guaranteedBalance: 0,
        },
      },
      //渠道列表
      channelList: [],
      sonPoolList: [],
      giftIdsType: 0,
    }
  },
  mounted() {
    this.getChannel()
    //获取幸运奖池配置
    this.getLuckGiftConfig()
    //获取个人保底
    this.getGuaranteed(1)
    this.getSignType()
  },
  methods: {
    openSonPool(list, type = 0) {
      this.giftIdsType = type
      if (list && list.length > 0) {
        this.giftIds = JSON.parse(JSON.stringify(list))
        this.sonPoolVisible = true
      } else {
        this.giftIds = []
        this.sonPoolVisible = true
      }
    },
    saveSonPoolGiftId() {
      const type = this.giftIdsType
      if (type === 0) {
        this.luckGift.list.distribution.giftIds = this.giftIds
      } else if (type === 1) {
        this.createLuckGift.list.distribution.giftIds = this.giftIds
      }
      this.$message.success('保存成功')
      this.closeSonPool()
      type == 0 && this.updateLuckyGifitConfig()
    },
    closeSonPool() {
      this.sonPool.giftId = null;
      this.giftIds = [];
      this.sonPoolVisible = false
    },
    addSonPoolGiftId() {
      if (!this.sonPool.giftId) {
        return this.$message.warning('礼物id不能为空')
      }
      if (this.giftIds.includes(this.sonPool.giftId)) {
        return this.$message.warning('礼物id已存在')
      }
      this.giftIds.push(+this.sonPool.giftId)
      this.sonPool.giftId = null
    },
    // 获取常量
    async getSignType() {
      const { data: res } = await this.$axios({
        method: 'GET',
        url: this.$store.getters.path.const_all,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          className: 'com.quhong.constant.activity.luckyGift.LuckyGiftSonPoolConstant',
        },
      })

      if (res.code != 0) {
        return this.$message.error(res.msg)
      } else {
        this.sonPoolList = res.data
      }
    },
    onInput() {
      this.$forceUpdate()
    },
    // 分割奖池添加
    poolAdd(type) {
      let that
      if (type === 1) {
        that = this.luckGift.list.guaranteedConfig.poolConfigs
      } else {
        that = this.createLuckGift.list.guaranteedConfig.poolConfigs
      }
      if (!that) {
        this.luckGift.list.guaranteedConfig.poolConfigs = [
          {
            poolKey: null,
            giftIds: [0],
          },
        ]
        this.$forceUpdate()
      } else {
        that.push({
          poolKey: null,
          giftIds: [0],
        })
        this.$forceUpdate()
      }
    },
    // 获取渠道选项
    async getChannel() {
      const { data: res } = await this.$axios({
        method: 'POST',
        url: this.$store.getters.path.channelList,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
        },
      })

      if (res.code != 0) {
        return this.$message.error(res.msg)
      } else {
        this.channelList = [
          {
            name: 'DEFAULT',
            value: 'DEFAULT',
            channelId: 99999,
          },
          ...res.data,
        ]
        this.luckGift.list.channel = this.channelList[0].value
      }
    },
    //置空创建配置
    clearCreate() {
      this.createState = false
      this.createLuckGift = JSON.parse(JSON.stringify(this.clearTemplete))
      console.log(this.createLuckGift)
    },
    //添加返奖率
    addMultiConfig() {
      let multi = this.createLuckGift.multi
      let rate = this.createLuckGift.rate
      let option = this.createLuckGift.multiConfig
      if (!multi || !rate || !option) {
        return this.$message.warning('配置类型、返奖倍速和概率不能为空')
      }

      switch (option) {
        case 'poolMultiList':
          this.createLuckGift.list.poolConfig.poolMultiList.push({
            multi: multi,
            rate: rate,
          })
          break
        case 'waterproofMultiList':
          this.createLuckGift.list.poolConfig.waterproofMultiList.push({
            multi: multi,
            rate: rate,
          })
          break
        case 'jackpotConfig':
          this.createLuckGift.list.jackpotConfig.multiConfigList.push({
            multi: multi,
            rate: rate,
          })
          break
        case 'guaranteedConfig':
          this.createLuckGift.list.guaranteedConfig.multiConfigList.push({
            multi: multi,
            rate: rate,
          })
          break
        case 'bigMultiList':
          this.createLuckGift.list.pointConfig.bigMultiList.push({
            multi: multi,
            rate: rate,
          })
          break
        case 'smallMultiList':
          this.createLuckGift.list.pointConfig.smallMultiList.push({
            multi: multi,
            rate: rate,
          })
          break
      }
      this.$message.success('添加成功')
    },
    //创建幸运礼物奖池配置
    async createLuckyGifitConfig() {
      // console.log('创建渠道')
      // console.log(this.createLuckGift.list)
      if (!this.createLuckGift.list.channel)
        return this.$message.warning('渠道不能为空')
      const { data: res } = await this.$axios({
        method: 'POST',
        url: this.$store.getters.path.config_giftlucky_create,
        data: {
          ...this.createLuckGift.list,
          operator: this.$store.getters.username,
        },
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
        },
      })

      if (res.code != 0) {
        return this.$message.error(res.msg)
      } else {
        this.$message.success('提交成功')
        this.clearCreate()
      }
    },
    //修改幸运礼物奖池配置
    async updateLuckyGifitConfig(state) {
      if (!this.luckGift.list.channel || !this.luckGift.list.id)
        return this.$message.error('提交失败')
      const { data: res } = await this.$axios({
        method: 'POST',
        url: this.$store.getters.path.config_giftlucky_put,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
        },
        data: {
          ...this.luckGift.list,
          channel: this.luckGift.list.channel,
          operator: this.$store.getters.username,
        },
      })

      if (res.code != 0) {
        return this.$message.error(res.msg)
      } else {
        this.luckGift.distributionUpdateState = false
        this.luckGift.jackpotConfigState = false
        this.luckGift.guaranteedConfigState = false
        this.luckGift.poolConfigState = false
        this.luckGift.waterPoolConfigState = false
        this.luckGift.pointConfigBigState = false
        this.luckGift.pointConfigSmallState = false
        this.$message.success('提交成功')
        this.getLuckGiftConfig()
      }
    },
    //个人保底表页变化
    guaranteedHandleCurrentChange(page) {
      getGuaranteed(page)
    },
    //获取幸运礼物配置
    async getLuckGiftConfig() {
      this.search.sonPool = this.search.sonPool ? this.search.sonPool : 1
      this.search.channel = this.search.channel ? this.search.channel : 'DEFAULT'
      const { data: res } = await this.$axios({
        type: 'GET',
        url: this.$store.getters.path.config_giftlucky_query,
        params: {
          ...this.search,
          username: this.$store.getters.username,
          token: this.$store.getters.token,
        },
      })
      let data
      if (res.code != 0) {
        return this.$message.error(res.msg)
      } else {
        data = res.data
          ? res.data
          : {
            id: null,
            channel: null,
            //分配配置
            distribution: {},
            //jockpot奖池配置
            jackpotConfig: {
              multiConfigList: [],
            },
            //个人保收奖池配置
            guaranteedConfig: {
              multiConfigList: [],
            },
            //兜底奖池配置
            poolConfig: {
              poolMultiList: [],
              waterproofMultiList: [],
            },
            //点控配置
            pointConfig: {
              bigMultiList: [],
              smallMultiList: [],
            },
            // 兜底奖池
            poolBalance: null,
            // jackpot奖池
            jackpotBalance: null,
            // 个人保底奖池总额
            guaranteedBalance: null,
          }
        console.log(res.data)
        this.luckGift.list = data
        this.$message.success('查询成功')
      }
    },
    //获取个人保底值
    async getGuaranteed(page) {
      let rid = this.guaranteed.rid ? +this.guaranteed.rid : ''
      console.log(rid)
      const { data: res } = await this.$axios({
        method: 'GET',
        url: this.$store.getters.path.config_giftlucky_guaranteed,
        params: {
          rid: rid,
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          page: page,
        },
      })
      if (res.code != 0) {
        return this.$message.error(res.msg)
      } else {
        this.$message.success('个人保底信息获取成功')
        //更新个人保底信息
        this.guaranteed.list = res.data.data
        this.guaranteed.total = res.data.total
      }
    },
  },
}
</script>

<style scoped lang="scss">
.gift-lucky {
  &__title {
    font-size: 28px;
    font-weight: 700;
    margin-bottom: 20px;
  }

  &__search {
    .searchBtn {
      margin-left: 10px;
    }
  }
}

.card {
  margin: 20px 0;
  //   height: 90vh;
}

.pool__item {
  border: 1px solid #ccc;
  width: max-content;
  padding: 2px 3px;
  display: inline-block;
  margin-right: 10px;
  margin-bottom: 5px;
}
</style>
